import { AbstractControl } from "@angular/forms";
import { GenericDialogComponent } from "./dialogs/generic.dialog/generic.dialog.component";
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MaincontainerComponent } from "../maincontainer/maincontainer.component";
import { ModalAlert } from "./dialogs/modal.alert/modal.alert.component";

export class Base {
    constructor(    
    ) {}    

    /**
    * Confirma si el FormControl tiene algún error    
    */
    hasError(control: AbstractControl) {
        if (control.errors ) {
            return true;
        }else{
            return false;
        }
    }

    /**
     * Imprime el error correspondiente en Form Control
     */
    printError(control: AbstractControl, mapMss?: any): string {
        let e = control.errors;
        let mss = "Error";

        for (const r in mapMss) {
            if (e && e[r]) {
                mss = mapMss && mapMss[r] ? mapMss[r] : mss;
                return mss;
            }
        }
        return "";
    }

    showMessageDialog(title: string, message: string, textButtonOne: string, textButtonTwo: string, isOneButton: boolean, iconType: number, matDialog: MatDialog, callback: any) {
        matDialog.open(
            GenericDialogComponent,
            {
                disableClose: true,
                data: {
                    title: title,
                    message: message,
                    textButtonOne: textButtonOne,
                    textButtonTwo: textButtonTwo,
                    isOneButton: isOneButton,
                    iconType: iconType
                }
            }
        ).afterClosed().subscribe((resultAfterClose: any) => {
            callback(resultAfterClose)
        })
    }
    openDialog(dialog: any, title: string, message: string, type: number, call: any) {
        dialog.open(ModalAlert, {
            disableClose: true,
            data: {
                title: title,
                message: message,
                type: type
            }
        }).afterClosed().subscribe((result: any) => {
            call(result)
        });
    }

    openDialogConfirm(dialog: any, title: string, message: string, type: number, call: any, config?: MatDialogConfig) {
        dialog.open(ModalAlert, {
            disableClose: true,
            data: {
                title: title,
                message: message,
                type: type,
                confirm: true
            },
            width: '520px',
            maxWidth: '95vw',
            ...config, 
        }).afterClosed().subscribe((result: any) => {
            call(result)
        });
    }
}